import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { createCopyModalVar } from "../../../graphql/globalVar/state";
import { useEventActions } from "../../../hooks/useEventActions";

function CreateCopyModal() {
  const eventId = useReactiveVar(createCopyModalVar);
  const { t } = useTranslation();
  const { createCopy, duplicateLoading } = useEventActions();

  return (
    <Modal
      show={eventId !== null}
      onHide={() => createCopyModalVar(null)}
      centered
      dialogClassName="modal-stop-tickets-sale"
      contentClassName="rounded-4 border-0"
    >
      <Modal.Header closeButton className="border-0 p-3">
        <Modal.Title className="fw-bold">
          {t("events.modals.createCopy.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center text-muted p-3 fs-6">
        <p className="fs-6 text-dark m-0 px-1 px-md-0">
          {t("events.modals.createCopy.body")}
        </p>
        <p className="fs-6 text-dark mt-3 mb-0 px-1 px-md-0">
          {t("events.modals.createCopy.note")}
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 w-100 pt-0">
        <Row className="g-2 w-100 m-0">
          <Col xs={4} md={6}>
            <Button
              variant="outline-dark"
              className="w-100 py-3 rounded-3 fw-normal"
              onClick={() => createCopyModalVar(null)}
              disabled={duplicateLoading}
            >
              {t("events.cancel")}
            </Button>
          </Col>
          <Col xs={8} md={6}>
            <Button
              variant="success"
              className="w-100 py-3 rounded-3 text-white"
              onClick={() => eventId && createCopy(eventId)}
              disabled={duplicateLoading}
            >
              {duplicateLoading
                ? t("events.modals.createCopy.creating")
                : t("events.modals.createCopy.confirm")}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateCopyModal;
